export default __webpack_public_path__ + "static/media/471.1cdf9b50.gif";